(function () {
  'use strict';
  var FEE = '43495605647';
  var messages = window.SparkleEmbroideryMessages || {};
  var queue = Promise.resolve();
  var checkingOut = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function isFee(line) { return String(line.variant_id || line.id) === FEE; }
  function pair(line) { return (line.properties || {})._embroidery_pair || ''; }
  function name(line) { return String((line.properties || {}).Embroidery || '').trim(); }
  function title(value) {
    return String(value || '').trim().replace(/&(amp|lt|gt|quot|#39);/g, function (entity) {
      return { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" }[entity];
    });
  }
  function problem(code) { return new Error(messages[code] || messages.failed); }
  function serialize(work) {
    var result = queue.then(work);
    queue = result.catch(function () {});
    return result;
  }
  async function request(path, data) {
    var response = await fetch(root + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: data ? JSON.stringify(data) : undefined,
    });
    var cart = await response.json();
    if (!response.ok || cart.status) throw problem('failed');
    return cart;
  }
  function linked(cart, id) {
    var lines = cart.items.filter(function (line) { return pair(line) === id; });
    var garments = lines.filter(function (line) { return !isFee(line); });
    var fees = lines.filter(isFee);
    if (garments.length !== 1 || fees.length !== 1) throw problem('repair');
    var garment = garments[0], fee = fees[0];
    if (!name(garment) || name(garment) !== name(fee) ||
        !fee.parent_relationship || fee.parent_relationship.parent_key !== garment.key) {
      throw problem('repair');
    }
    return { garment: garment, fee: fee };
  }
  function validLegacy(cart) {
    var lines = cart.items.filter(function (line) { return !pair(line) && (isFee(line) || name(line)); });
    var totals = new Map();
    for (var line of lines) {
      if (!name(line) || String((line.properties || {}).is_final_sale).toLowerCase() !== 'true') return false;
      var product = title(isFee(line) ? line.properties.For : line.product_title);
      if (!product) return false;
      var key = JSON.stringify([product, name(line)]);
      var value = totals.get(key) || { garment: 0, fee: 0 };
      value[isFee(line) ? 'fee' : 'garment'] += line.quantity;
      totals.set(key, value);
    }
    return Array.from(totals.values()).every(function (value) { return value.garment === value.fee; });
  }
  async function changeQuantity(id, quantity) {
    return serialize(async function () {
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw problem('failed');
      var cart = await request('cart.js');
      var line = cart.items.find(function (item) { return item.key === id; });
      if (!line) return cart;
      if (!pair(line)) {
        if (isFee(line) || name(line)) {
          if (quantity !== 0) throw problem('repair');
        }
        return request('cart/change.js', { id: line.key, quantity: quantity });
      }
      var items = linked(cart, pair(line));
      if (isFee(line) && quantity === 0) {
        cart = await request('cart/change.js', { id: items.fee.key, quantity: 0 });
        var garment = cart.items.find(function (item) { return pair(item) === pair(line) && !isFee(item); });
        if (!garment) return cart;
        var properties = Object.assign({}, garment.properties);
        delete properties.Embroidery;
        delete properties.is_final_sale;
        delete properties['Return policy'];
        delete properties._embroidery_pair;
        properties._embroidery_removed = 'true';
        return request('cart/change.js', { id: garment.key, quantity: garment.quantity, properties: properties });
      }
      cart = await request('cart/change.js', { id: items.garment.key, quantity: quantity });
      if (quantity === 0) return cart;
      items = linked(cart, pair(line));
      if (items.garment.quantity !== quantity) throw problem('failed');
      if (items.fee.quantity !== quantity) {
        cart = await request('cart/change.js', { id: items.fee.key, quantity: quantity });
      }
      items = linked(cart, pair(line));
      if (items.fee.quantity !== items.garment.quantity) throw problem('repair');
      return cart;
    });
  }
  async function ensure() {
    return serialize(async function () {
      var cart = await request('cart.js');
      if (!validLegacy(cart)) {
        throw problem('repair');
      }
      var ids = Array.from(new Set(cart.items.map(pair).filter(Boolean)));
      for (var id of ids) {
        var items = linked(cart, id);
        if (items.garment.quantity !== items.fee.quantity) throw problem('repair');
        for (var feeLine of [false, true]) {
          var current = linked(cart, id);
          var line = feeLine ? current.fee : current.garment;
          if (String((line.properties || {}).is_final_sale).toLowerCase() !== 'true') {
            var properties = Object.assign({}, line.properties, { is_final_sale: 'true' });
            cart = await request('cart/change.js', { id: line.key, quantity: line.quantity, properties: properties });
          }
        }
      }
      return cart;
    });
  }
  window.SipEmbroideryCart = { changeQuantity: changeQuantity, ensure: ensure };
  // Delegate once so refreshed cart rows and clicks on nested icons use the same updater.
  document.addEventListener('click', function (event) {
    var control = event.target.closest('.select-plus[data-id], .select-minus[data-id], .cart-drawer_item_remove[data-id]');
    if (!control) return;
    var row = control.closest('.cart-item-container');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var quantity = 0;
    if (!control.classList.contains('cart-drawer_item_remove')) {
      var current = Number(row.querySelector('.cart-drawer_item_qty-selector').textContent.trim());
      quantity = Math.max(0, current + (control.classList.contains('select-plus') ? 1 : -1));
    }
    if (typeof window.updateCartItemQuantity === 'function') {
      window.updateCartItemQuantity((control.dataset.key || control.dataset.id), quantity);
    } else {
      control.setAttribute('aria-busy', 'true');
      changeQuantity((control.dataset.key || control.dataset.id), quantity).then(function () { window.location.reload(); })
        .catch(function (error) { window.alert(error.message); })
        .finally(function () { control.removeAttribute('aria-busy'); });
    }
  }, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.chkout, a[href="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    button.setAttribute('aria-busy', 'true');
    ensure().then(function () { window.location.assign(root + 'checkout'); })
      .catch(function (error) { window.alert(error.message); })
      .finally(function () { checkingOut = false; button.removeAttribute('aria-busy'); });
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    ensure().then(function () { window.location.assign(root + 'checkout'); })
      .catch(function (error) { window.alert(error.message); })
      .finally(function () { checkingOut = false; });
  }, true);
})();
